import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1>Complexe Scolaire privé Sahwa</h1>
                <h1>Jardin-Primaire-Collège-Secondaire</h1>
                <h2>Tel: 41900800-38483438</h2>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1> مـجــمـــع مدارس الصــحوة الحرة</h1>
                <h1> روضة - ابتدائية - إعدادية - ثانوية </h1>
                <h2> 41900800-38483438: الهاتف</h2>
            </div>
        </div>
    )
}

export default Entete